import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import classnames from 'classnames';
import messages from './messages';
import GorgiasLogo from './svgs/gorgias-logo.svg';

import style from './style.module.less';

export const Gorgias = () => {
  const intl = useIntl();
  return (
    <div className={style['settings-section']}>
      <img alt={intl.formatMessage(messages.gorgiasLogo)} src={GorgiasLogo} />
      <div className={classnames(style.subtext, style['gorgias-subtext'])}>
        <FormattedMessage
          {...messages.gorgias}
          values={{
            a: (chunks) => (
              <a href='https://help.shipstation.com/hc/en-us/articles/360060624552-Gorgias' rel='noreferrer' target='_blank'>
                {chunks}
              </a>
            ),
          }}
        />
      </div>
    </div>
  );
};
